
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class AttemptsGrid extends Serenity.EntityGrid<AttemptsRow, any> {
        protected getColumnsKey() { return AttemptsColumns.columnsKey; }
        protected getDialogType() { return AttemptsDialog; }
        protected getIdProperty() { return AttemptsRow.idProperty; }
        protected getInsertPermission() { return AttemptsRow.insertPermission; }
        protected getLocalTextPrefix() { return AttemptsRow.localTextPrefix; }
        protected getService() { return AttemptsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}